export const tenantInfoActions = {
  handleTenantLocationCode: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantLocationCode", payload);
  },
  handleTenantFirstName: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantFirstName", payload);
  },
  handleTenantLastName: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantLastName", payload);
  },
  handleTenantEmailAddress: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantEmailAddress", payload);
  },
  handleTenantPhone: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantPhone", payload);
  },
  handleTenantHomeAddress: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantHomeAddress", payload);
  },
  handleTenantAddressTwo: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantAddressTwo", payload);
  },
  handleTenantCity: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantCity", payload);
  },
  handleTenantState: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantState", payload);
  },
  handleTenantZipCode: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantZipCode", payload);
  },
  handleTenantCounty: ({ commit }: { commit: Function }, payload: string) => {
    commit("setTenantCounty", payload);
  }
};
